import { Avatar, Body, Chip, Heading } from 'copilot-design-system';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useChannelStateContext } from 'stream-chat-react';

import { FlagsContext } from 'src/context/flagsContext';
import { useCrmContext } from 'src/features/crm/CrmContext';
import { AssistantUserID } from 'src/store/clients/types';

const chipStyles =
  'px-3 py-[5px] text-base text-gray-small border-non-hover-border hover:bg-gray-150';

export const AssistantEmptyState = () => {
  const { t } = useTranslation();
  const { channel } = useChannelStateContext();
  const { EnableLegacyAvatarColorMapping } = useContext(FlagsContext);

  const {
    name = 'Assembly',
    image = '',
    fallbackColor,
    id,
  } = (channel.state.members[AssistantUserID] ?? {}).user ?? {};

  const crmContext = useCrmContext();
  const entityType = crmContext?.entityType;
  if (!entityType) {
    return null;
  }

  return (
    <div className="px-4 py-3">
      <div className="flex gap-2 items-start">
        <Avatar
          className="w-[25px] h-[25px] [&_img]:w-[25px] [&_img]:h-[25px]"
          src={image}
          alt={name}
          variant="circle"
          size="md"
          fallbackColor={fallbackColor}
          text={(name ?? id)?.at(0)?.toUpperCase()}
          useNewColors={EnableLegacyAvatarColorMapping}
        />
        <div>
          <Heading className="text-black-heading text-[15px] font-semibold leading-6">
            {name}
          </Heading>
          <Body className="text-black-heading text-[15px] leading-6 mt-1">
            Use the Internal Chat tab to talk privately with your team, or tag
            @Assembly to help you.
          </Body>
          <div className="flex flex-col gap-2 items-start mt-5">
            <Chip
              className={chipStyles}
              variant="outlined"
              label={t(
                ($) =>
                  $.assistant.empty_state.suggested_actions.what_can_you_do
                    .label,
              )}
              onClick={() => {
                void channel.sendMessage({
                  text: t(
                    ($) =>
                      $.assistant.empty_state.suggested_actions.what_can_you_do
                        .message,
                  ),
                  mentioned_users: [AssistantUserID],
                });
              }}
            />
            <Chip
              className={chipStyles}
              variant="outlined"
              label={t(
                ($) =>
                  $.assistant.empty_state.suggested_actions.tell_me_about[
                    entityType
                  ].label,
              )}
              onClick={() => {
                void channel.sendMessage({
                  text: t(
                    ($) =>
                      $.assistant.empty_state.suggested_actions.tell_me_about[
                        entityType
                      ].message,
                  ),
                  mentioned_users: [AssistantUserID],
                });
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
